import * as React from 'react';
import { ExtendedDialog } from '@uifabric/portal-ux/lib/components/ExtendedDialog';
import { DialogFooter, PrimaryButton, DefaultButton, Spinner } from '@fluentui/react';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { connect, useDispatch } from 'react-redux';
import { AccountActions, IRootAccountState } from '../../models';

interface ILeaveOrgSuccessDialogProps {
  readonly targetOrg: string;
}

const LeaveOrgConfirmationDialog: React.FC<ILeaveOrgSuccessDialogProps> = ({ targetOrg }) => {
  const [t] = useLocalization('Account');
  const dispath = useDispatch();
  const [isLeaving, setIsLeaving] = React.useState(false);

  const submit = React.useCallback(() => {
    setIsLeaving(true);
    dispath({ type: AccountActions.submitLeaveOrganization });
  }, [dispath]);
  const cancel = React.useCallback(() => {
    dispath({ type: AccountActions.cancelLeaveOrganization });
  }, [dispath]);

  const renderSpinner = React.useCallback(() => {
    return (
      <Spinner
        styles={{
          circle: {
            color: '#ffffff'
          }
        }}
      />
    );
  }, []);

  return (
    <div>
      <ExtendedDialog
        hidden={false}
        isClickableOutsideFocusTrap={false}
        dialogContentProps={{
          title: t('confirmToLeaveOrg', {
            orgName: targetOrg
          }),
          showCloseButton: false
        }}
      >
        <p>{t('leaveDialogTextP1', { orgName: targetOrg })}</p>
        <p>{t('leaveDialogTextP2', { orgName: targetOrg })}</p>
        <DialogFooter>
          <PrimaryButton text={t('Leave')} onClick={submit} onRenderIcon={isLeaving ? renderSpinner : undefined} />
          <DefaultButton text={t('cancel')} onClick={cancel} disabled={isLeaving} />
        </DialogFooter>
      </ExtendedDialog>
    </div>
  );
};

const mapStateToProps = (state: IRootAccountState): ILeaveOrgSuccessDialogProps => {
  return {
    targetOrg: state.account.currentOrgDisplayName
  };
};

export const ConnectedLeaveOrgConfirmationDialog = connect(mapStateToProps)(LeaveOrgConfirmationDialog);
